export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6a-33695e992c785ddd2d0a3a22d7c771a1.webp";